import { render, staticRenderFns } from "./DataAnalysisDashboardGruppiModalEditComponent.vue?vue&type=template&id=4e50ebb7"
import script from "./DataAnalysisDashboardGruppiModalEditComponent.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDashboardGruppiModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports